export enum ReportType {
  LoadingReport = 0,
  ContainerReport = 1,
  OrderReport = 2,
}
